import React, { Component } from 'react';
import Translation from '../translation/translation';
import Context from '../context/context';

class Login extends Component {



  constructor(props) {
    super();

    this.state = { ErrorJson: Context.ErrJson };
  }







  render() {
    return (

      <div className="panel panel-default">
        <div className="panel-heading">{Translation.Trans("error")}</div>
        <div className="panel-body">
          {Translation.Trans("systemerror")}
          <p>
            MESSAGE_TEXT:
            {this.state.ErrorJson.MESSAGE_TEXT}
          </p>
          <p>
            PG_EXCEPTION_DETAIL:
            {this.state.ErrorJson.PG_EXCEPTION_DETAIL}
          </p>
          <p>
            PG_EXCEPTION_HINT:
            {this.state.ErrorJson.PG_EXCEPTION_HINT}
          </p>
        </div>
      </div>


    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/pages/error.js